var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from 'axios';
import { API_KEY, API_URL } from './api';
const cache = new Map();
const checkSingleEmail = (email, log) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    if (!cache.has(email)) {
        const result = yield axios.get(`${API_URL}?api=${API_KEY}&email=${email}`);
        if (result.data) {
            cache.set(email, result.data);
        }
    }
    //if the call is failing, assume we should accept it (send_transactional)
    const returnValue = (_a = cache.get(email)) !== null && _a !== void 0 ? _a : { debounce: { send_transactional: '1' }, success: '0' };
    log === null || log === void 0 ? void 0 : log.info('checkSingleEmail', returnValue);
    return returnValue;
});
export default checkSingleEmail;
